import type { AppEnvironment } from './environment.types';

export const ENVIRONMENT: AppEnvironment = {
  production: false,
  mockEnabled: false,
  apiMobileUrl: 'https://testapik8.puntosleal.com/saas',
  apiBaseLeal: 'https://apiqa.leal.co',
  lealOAuth: {
    authUrl: 'https://qaauth.leal.co',
    clientAuthorizationHeader:
      'Basic NGVsdW92aG5zcWNmMmJjMXBncTBiNW5tNzI6ZnR2aTE3azNvcjBuNTRoMnFhbnB1cnE2bTEwMWI0YWttdjhpbnFuZ3JzOGNmc3ZqdDFz',
  },
  firebase: {
    apiKey: 'AIzaSyC_1H1TalAVaTrfRPTGUqOyaAzhZtsCnbs',
    authDomain: 'leal-landings-dinamicas.firebaseapp.com',
    databaseURL: 'https://test-leal-landings-dinamicas.firebaseio.com/',
    projectId: 'leal-landings-dinamicas',
    storageBucket: 'leal-landings-dinamicas.appspot.com',
    messagingSenderId: '584099873291',
    appId: '1:584099873291:web:cb5fddd830add7c3f0fd0e',
    measurementId: 'G-RKG608TTMW',
    landingsCollectionPath: 'landings',
  },
  leaderboardEventsApiUrl: 'https://apiqa.leal.co/api/v1/leaderboard/events',
};
